export function log({ message, enabled, objects }) {
    if (enabled) {
        console.log(`Fusion::paint ${message}`, objects);
    }
}
//# sourceMappingURL=log.js.map